import { m } from 'framer-motion';
import { Box, Typography } from '@mui/material';
import { MotionContainer, varFade } from '../animate';

interface Props {
  errorMessage?: string | JSX.Element;
}

const ErrorBanner: React.FC<Props> = ({ errorMessage }) => {
  if (!errorMessage) {
    return null;
  }

  return (
    <MotionContainer>
      <Box
        component={m.div}
        variants={varFade().in}
        sx={{
          mb: 6,
          p: 3,
          border: (theme) => `1px solid ${theme.palette.error.main}`,
          backgroundColor: 'rgba(244, 246, 248, 1)',
        }}
      >
        <Typography color="error">{errorMessage}</Typography>
      </Box>
    </MotionContainer>
  );
};

export default ErrorBanner;
